module.exports = __webpack_public_path__ + "static/assets/9ac6c04f716186ed9e144303687bb933.svg";